import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import App from 'src/app/App';
import { Provider } from 'react-redux';
import store from './store';

import * as Sentry from '@sentry/react';

import { SENTRY_DNS, SENTRY_ENVIRONMENT } from 'src/appConfig';
import { setupTracing } from './infrastructure/observability/tracing';
import { dropConsoleLoggedNetworkErrors } from './infrastructure/observability/sentryFilters';

// @ts-expect-error //  this is what makes the translation work. DO NOT REMOVE IT
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from './infrastructure/i18n/i18next.client';

// Initialise OTel tracing before anything else so the XHR instrumentation
// patches XMLHttpRequest before Axios (or any other caller) uses it.
setupTracing();

Sentry.init({
    dsn: SENTRY_DNS,
    environment: SENTRY_ENVIRONMENT,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    // `captureConsoleIntegration` turns any third-party `console.error` into an issue,
    // including ones the library that logged them already recovered from.
    ignoreErrors: [
        // Reading `cssRules` of the cross-origin stylesheet the Google Maps JS API
        // injects. html-to-image logs it while building a screenshot and carries on.
        /Failed to read the 'cssRules' property/,
    ],
    beforeSend: dropConsoleLoggedNetworkErrors,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = document.getElementById('root') as HTMLDivElement;
ReactDOM.createRoot(root).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
);

reportWebVitals();
